
export const typeOwner = [
    { id: 0, name: 'เจ้าของห้อง' },
    { id: 1, name: 'ผู้เช่า' },
]


// WEBPACK FOOTER //
// ./src/constant/TypeOwner.js